var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12.5,
    stroke: "#2177FE",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 21.25C12.2896 18.1973 17.679 18.0535 20.625 21.25M18.1189 11.875C18.1189 13.6009 16.7178 15 14.9894 15C13.2611 15 11.86 13.6009 11.86 11.875C11.86 10.1491 13.2611 8.75 14.9894 8.75C16.7178 8.75 18.1189 10.1491 18.1189 11.875Z",
    stroke: "#2177FE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountlist);
export default __webpack_public_path__ + "static/media/Accountlist.1b3fae9a7704d9c43cc1ada448418e27.svg";
export { ForwardRef as ReactComponent };